import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactHero = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = window.innerWidth < 768 ? 120 : 100;
      const elementPosition = element?.getBoundingClientRect()?.top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-brand text-white overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <Icon name="MessageCircle" size={20} color="white" className="sm:w-6 sm:h-6" />
                </div>
                <span className="text-sm sm:text-lg font-medium text-white/90">Multi-Channel Engagement Hub</span>
              </div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight">
                Let's Navigate Your Data Journey Together
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-white/90 leading-relaxed">
                Connect with our data strategy experts through your preferred channel. From strategic consultations to technical assessments, we're here to guide your transformation.
              </p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div className="flex items-center space-x-3 text-white/90 text-sm sm:text-base">
                <Icon name="Clock" size={18} className="flex-shrink-0" />
                <span>24-hour response guarantee</span>
              </div>
              <div className="flex items-center space-x-3 text-white/90 text-sm sm:text-base">
                <Icon name="Shield" size={18} className="flex-shrink-0" />
                <span>GDPR compliant consultations</span>
              </div>
              <div className="flex items-center space-x-3 text-white/90 text-sm sm:text-base">
                <Icon name="MapPin" size={18} className="flex-shrink-0" />
                <span>Dublin-based expertise</span>
              </div>
              <div className="flex items-center space-x-3 text-white/90 text-sm sm:text-base">
                <Icon name="Users" size={18} className="flex-shrink-0" />
                <span>C-suite focused approach</span>
              </div>
            </div>
          </div>
          
          <div className="lg:text-right">
            <div className="inline-block w-full lg:w-auto bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 border border-white/20">
              <div className="space-y-6">
                <div className="text-center">
                  <h3 className="text-xl sm:text-2xl font-semibold text-white mb-2">Ready to Start?</h3>
                  <p className="text-sm sm:text-base text-white/80">Choose your preferred engagement method</p>
                </div>
                
                <div className="space-y-3">
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="Calendar"
                    iconPosition="left"
                    className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/40 min-h-[48px] text-sm sm:text-base"
                    onClick={() => navigate('/schedule-consultation')}
                  >
                    Schedule Consultation
                  </Button>
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="FileText"
                    iconPosition="left"
                    className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/40 min-h-[48px] text-sm sm:text-base"
                    onClick={() => navigate('/request-proposal')}
                  >
                    Request Proposal
                  </Button>
                  <Button
                    variant="outline"
                    fullWidth
                    iconName="Calculator"
                    iconPosition="left"
                    className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/40 min-h-[48px] text-sm sm:text-base"
                    onClick={() => scrollToSection('engagement-options')}
                  >
                    Explore Options
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-32 h-32 bg-white/5 rounded-full blur-xl hidden lg:block"></div>
      <div className="absolute bottom-20 left-20 w-24 h-24 bg-secondary/20 rounded-full blur-lg hidden lg:block"></div>
    </section>
  );
};

export default ContactHero;